import ShipmentForm from "../ShipmentForm";
import { ShipmentFormProps } from "../ShipmentForm/ShipmentForm";

type EditShipmentFormProps = {
  onSubmit: ShipmentFormProps["onSubmit"];
  loading: boolean;
  isChildLoad: boolean;
  isSplit: boolean;
  isFromSplit: boolean;
};

const EditShipmentForm = ({
  onSubmit,
  loading,
  isChildLoad,
  isSplit,
  isFromSplit,
}: EditShipmentFormProps) => {
  return (
    <ShipmentForm
      loading={loading}
      editMode
      isChildLoad={isChildLoad}
      isSplit={isSplit}
      isFromSplit={isFromSplit}
      onSubmit={onSubmit}
    />
  );
};

export default EditShipmentForm;
